import { reactive, readonly } from 'vue'

const state = reactive({
  tourAutostartNonce: 0
})

export function getUiState() {
  return readonly(state)
}

export function requestTourAutostart() {
  state.tourAutostartNonce += 1
}
